import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=921f418c&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=921f418c&prod&lang=scss&"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=921f418c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921f418c",
  null
  
)

export default component.exports